// Original vs adapted, aligned row by row so a teacher can see exactly what moved.
import type { ReactNode } from "react";
import type { Lesson } from "../../shared/catalog";
import { docFromLesson, type LessonDoc } from "../../shared/lesson-model";
import { StageStrip } from "./StageStrip";

export function CompareView({ lesson, adapted }: { lesson: Lesson; adapted: LessonDoc }) {
  const orig = docFromLesson(lesson);
  const rows: [string, (d: LessonDoc) => ReactNode][] = [
    ["Level and time", (d) => `${d.level} · ${d.duration} min`],
    ["Objective", (d) => d.objective],
    ["Timeline", (d) => (
      <>
        <StageStrip stages={d.stages} size="md" />
        <ul className="cmp-stages">{d.stages.map((s, i) => <li key={i}><b>{s.minutes}′</b> {s.name}</li>)}</ul>
      </>
    )],
    ["Materials", (d) => d.materials.join(" · ")],
    ["Main activity", (d) => (d.stages.find((s) => s.kind === "main") ?? d.stages[1])?.teacher],
    ["Practice", (d) => (d.stages.find((s) => s.kind === "practice") ?? d.stages[2])?.teacher],
    ["Support", (d) => d.support],
    ["Extension", (d) => d.extension],
  ];
  return (
    <div className="compare" role="table" aria-label="Original and adapted lesson compared">
      <div className="cmp-row cmp-head" role="row">
        <span role="columnheader" />
        <span role="columnheader">Handbook original</span>
        <span role="columnheader">Adapted for your class</span>
      </div>
      {rows.map(([label, render]) => (
        <div className="cmp-row" role="row" key={label}>
          <span className="cmp-label" role="rowheader">{label}</span>
          <div role="cell">{render(orig)}</div>
          <div role="cell" className="cmp-new">{render(adapted)}</div>
        </div>
      ))}
    </div>
  );
}
